module.exports = __webpack_public_path__ + "img/ic-register-airwallex.590cf9fc.svg";